import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'drug', en);

const DrugListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Drugs',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DRUG,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/drug/list',
      component: React.lazy(() => import('./DrugList')),
    },
  ],
};

export default DrugListConfig;
